var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c("PageHeader", {
        attrs: {
          "no-padding": "",
          subtitle: "Manage the Continuous Stations linked from Aquarius.",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-2" },
        [
          _c(
            "v-alert",
            {
              key: "alert",
              staticClass: "my-0",
              attrs: {
                outline: "",
                type: "error",
                value: !_vm.aquariusSynchronizer,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n        The Aquarius Synchronizer is offline.\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("v-card-text", [
            _vm._v(
              "\n      The stations below were found in Aquarius during a "
            ),
            _c("strong", [_vm._v("Sync")]),
            _vm._v(" and linked to EnviroData continuous\n      stations. "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h4", [_vm._v("Linked Stations")]),
            _vm._v("\n      Stations are initially linked by their "),
            _c("strong", [_vm._v("Site Identifier")]),
            _vm._v(
              ". Once linked, even if the Site\n      Identifier is changed\n      in Aquarius, the link is preserved and the Site Identifier in the table below will be updated. "
            ),
            _c("br"),
            _vm._v(
              "\n      When a station is deleted in Aquarius, the linked station below is set to inactive. When a station in\n      Aquarius is found with the same Site Identifier as an inactive station, the station will become active. "
            ),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h4", [_vm._v("Deleting Stations")]),
            _vm._v("\n      To permanently delete a linked station, "),
            _c("strong", [_vm._v("delete")]),
            _vm._v(
              " the station from EnviroData. All tenant\n      time series settings for that station will be lost!\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Aquarius Stations", search: "aquarius stations" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [_c("SyncAquariusStationsDialog")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-divider"),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              pagination: _vm.pagination,
              headers: _vm.headers,
              items: _vm.stations,
              search: _vm.search,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function ({ item }) {
                  return [
                    _c("td", [_vm._v(_vm._s(item.AquariusId))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.StationId))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(item.Description))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        item.IsDeleted
                          ? _c("v-icon", { attrs: { color: "error" } }, [
                              _vm._v("clear"),
                            ])
                          : _c("v-icon", { attrs: { color: "success" } }, [
                              _vm._v("done"),
                            ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: item.IsArchived,
                              loading: item.deleting,
                              small: "",
                              color: "error",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.hardDelete(item)
                              },
                            },
                          },
                          [
                            _c("v-icon", [_vm._v("delete_forever")]),
                            _vm._v("\n            Delete\n          "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }